import type { EditorCommand } from '@atlaskit/editor-common/types';

import { type MalleableUiPluginMeta, malleableUiPluginKey } from '../pm-plugins/plugin-key';

export type SetRemixImageMediaIdProps = {
	/** Media (file) id of the inserted image, or `undefined` to clear a previous remix's id. */
	mediaId: string | undefined;
};

/**
 * Records (or clears) the media id of the image the remix just inserted, so the ready-signal UI can
 * scroll to that media node. Set once the upload+insert lands (which happens after the remix reports
 * ready); cleared when a new remix starts.
 */
export const setRemixImageMediaId =
	({ mediaId }: SetRemixImageMediaIdProps): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, {
			remixImageMediaId: mediaId,
		} satisfies MalleableUiPluginMeta);

		return tr;
	};
